import { forwardRef, useImperativeHandle, useState } from "react";
import InsightItem from "./InsightItem";

const cardContainerStyle = Object.assign(
    {},
    {
        display: "flex",
        flexDirection: "row-reverse",
        marginLeft: "15%",
        marginRight: "15%",
        overflowX: "scroll"
    }
);
const cardContainerStyleForMobile = Object.assign(
    {},
    { display: "flex", flexDirection: "row-reverse", overflow: "scroll" }
);

export default forwardRef(({ isMobile }, ref) => {
    useImperativeHandle(ref, () => ({
        setInsights: (items) => {
            setInsights(items);
        }
    }));

    const [insights, setInsights] = useState([]);

    return (
        <div id="insightsContainer" style={isMobile ? cardContainerStyleForMobile : cardContainerStyle}>
            {insights.map((item, index) => (
                <InsightItem key={index} item={item} isMobile={isMobile} />
            ))}
        </div>
    );
});
